import { defineComponent as _defineComponent } from 'vue'
import { Modal, Heading, BaseText } from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';
interface Props {
  isOpen: boolean;
  description: string;
}
interface EmitEvents {
  (event: 'close'): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ExpectedDateModal',
  props: {
    isOpen: { type: Boolean },
    description: null
  },
  emits: ["close"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {



function emitClose() {
  emit('close');
}

return { __sfc: true,emit, emitClose, Modal, Heading, BaseText, Portal }
}

})